<template>
  <!-- <div @click="selected" v-on:keydown="keyPress"> -->
  <div>
    <!-- Slot used for handle -->
    <slot></slot>
    <div
      v-if="tag == 'p'"
      class="p"
      ref="editable"
      :contenteditable="editable"
      v-on="listeners"
    />
    <h1
      v-if="tag == 'h1'"
      ref="editable"
      :contenteditable="editable"
      v-on="listeners"
    />
    <h2
      v-if="tag == 'h2'"
      ref="editable"
      :contenteditable="editable"
      v-on="listeners"
    />
    <h2
      v-if="tag == 'h3'"
      ref="editable"
      :contenteditable="editable"
      v-on="listeners"
    />

    <v-menu
      v-model="showMenu"
      :position-x="position.x"
      :position-y="position.y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index">
          <v-list-item-title>
            <v-btn>{{ item.title }}</v-btn>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
    },
    totalElements: {
      // total elements for content
      type: Number,
    },
  },
  data() {
    return {
      element: {},
      position: {},
      showMenu: false,
      items: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      defaultElement: {
        tag: "p",
        innerHtml: "New Content",
      },
    };
  },
  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
    tag() {
      // get tag from v-model
      return this.value.tag;
    },
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$emit("input", this.element);
        }
      },
    },
  },
  methods: {
    onInput(e) {
      //console.log("e", e);

      let check = /^\/$/.test(e.target.innerText); // checks if '/ ' is entered to trigger menu
      if (check) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }

      this.element.innerHtml = e.target.innerText;
      this.$emit("input", this.element);
    },
    /* eslint-disable */
    selected(e) {
      // let el = this.$el;
      // this.position = el.getBoundingClientRect();
      // let caretPos = this.getCaretCoordinates();
      // var x = e.clientX;
      // var y = e.clientY;
      // let mouse = { "X coords: ": x, "Y coords: ": y };
      // console.log("position", this.position);
      // console.log("mouse", mouse);
      // console.log("caretPos", caretPos);
    },
    init() {
      this.element = this.value;
      this.$refs.editable.innerText = this.element.innerHtml;
    },
  },
  mounted() {
    this.init();
    window.setCursor = this.setCursor;
    window.getCursorPosition = this.getCursorPosition;
  },
};
</script>

<style lang="scss" scoped>
p::before {
  content: "test";
  position: absolute;
  color: gray;
}
[contenteditable="true"] {
  background-color: rgba(217, 245, 255, 0.5);
  outline: 0;
  &:empty {
    &::before {
      content: "Enter Content";
      position: absolute;
      margin-left: 5px;
      color: gray;
    }
  }
}
</style>
